import { FeatureIdsEnum, IFeature } from "@models/Account.models";

export const isFeatureAllowed = (
  feature: FeatureIdsEnum,
  permittedFeatures: IFeature[]
) => {
  const isAllowed = permittedFeatures.some((feat) => feat.feature_id === feature && feat.allowed);
  return permittedFeatures.some((feat) => feat.feature_id === feature && feat.allowed);
}
